import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskNeedGiveUI = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskNeedGiveUI;
